import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import vi from './vi.json';
import zh from './zh.json';
import fr from './fr.json';

// Available languages configuration
// Add new languages here for easy expansion
export const languages = [
  { code: 'en', name: 'English', nativeName: 'English' },
  { code: 'vi', name: 'Vietnamese', nativeName: 'Tiếng Việt' },
  { code: 'zh', name: 'Chinese', nativeName: '中文' },
  { code: 'fr', name: 'French', nativeName: 'Français' },
];

// Get available language codes
export const languageCodes = languages.map(lang => lang.code);

// Get native name for a language code
export const getLanguageNativeName = (code) => {
  const lang = languages.find(l => l.code === code);
  return lang ? lang.nativeName : code;
};

const getInitialLanguage = () => {
  if (typeof window !== 'undefined' && window.localStorage) {
    const savedLanguage = localStorage.getItem('language');
    if (savedLanguage && languageCodes.includes(savedLanguage)) {
      return savedLanguage;
    }
  }

  // Detect from timezone (Vietnam is UTC+7)
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const vietnamTimezones = ['Ho_Chi_Minh', 'Hanoi', 'Vietnam', 'Saigon'];
  if (vietnamTimezones.some(tz => timezone.includes(tz))) {
    return 'vi';
  }

  // Detect from browser language
  if (typeof navigator !== 'undefined') {
    const browserLang = navigator.language || navigator.userLanguage;
    for (const lang of languages) {
      if (browserLang.toLowerCase().startsWith(lang.code)) {
        return lang.code;
      }
    }
  }

  return 'en';
};

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      vi: { translation: vi },
      zh: { translation: zh },
      fr: { translation: fr },
    },
    lng: getInitialLanguage(),
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

// Helper function to switch to next language (for cycling)
export const getNextLanguage = (currentLang) => {
  const currentIndex = languageCodes.indexOf(currentLang);
  const nextIndex = (currentIndex + 1) % languageCodes.length;
  return languageCodes[nextIndex];
};

export default i18n;
